import { render, staticRenderFns } from "./joinCompany.vue?vue&type=template&id=a0baaaca&scoped=true"
import script from "./joinCompany.vue?vue&type=script&lang=js"
export * from "./joinCompany.vue?vue&type=script&lang=js"
import style0 from "./joinCompany.vue?vue&type=style&index=0&id=a0baaaca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0baaaca",
  null
  
)

export default component.exports